import React from 'react'

import { useRecipe } from '../../model/context'
import { useGetSurchargeForRecipeIdHook } from '../../model/context/useGetSurchargeForRecipeId'

import { formatSurcharge } from '../../utils/formatSurcharge'

import {
  Box,
  Text,
  FontFamily,
  FontWeight,
  JustifyContent,
  FlexDirection,
  Display,
  DisplayPosition,
  Color,
} from '@gousto-internal/citrus-react'
import { SoldOutOverlay } from '../SoldOutOverlay'

export const RecipeTilePurchaseInfo: React.FC = () => {
  const { id: recipeId, isFineDineIn } = useRecipe()

  const useGetSurchargeForRecipeId = useGetSurchargeForRecipeIdHook()
  const surcharge = useGetSurchargeForRecipeId(recipeId)

  const justifyContent = !!surcharge ? JustifyContent.SpaceBetween : JustifyContent.FlexEnd
  const overlayBgColor = isFineDineIn ? Color.ColdGrey_800 : Color.White

  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Row} justifyContent={justifyContent}>
      {Boolean(surcharge) && (
        <Box position={DisplayPosition.Relative} style={{ paddingTop: '8px' }}>
          <SoldOutOverlay backgroundColor={overlayBgColor} />
          <Text size={2} fontFamily={FontFamily.Book} fontWeight={FontWeight.Normal}>
            {formatSurcharge(surcharge)} a serving
          </Text>
        </Box>
      )}
    </Box>
  )
}
